// import Vue from 'vue'
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
// Vue.use(ElementUI)

// Message.install = function (Vue, options) {undefined
//   Vue.prototype.$message = Message
// }
import { Message } from 'element-ui';


export function success (msg,time = 1100, showClose = true) {
  Message({
    showClose: showClose,
    message: msg,
    type: 'success',
    duration: time
  })
}
export function error (msg,time = 1100, showClose = true) {
  Message({
    showClose: showClose,
    message: msg,
    type: 'error',
    duration: time
  })
}
export function warning (msg,time = 1100, showClose = true) {
  Message({
    showClose: showClose,
    message: msg,
    type: 'warning',
    duration: time
  })
}